if (!customElements.get('rj-size-guide')) {
  customElements.define('rj-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-calculate]').addEventListener('click', () => this.calculate());
      this.addEventListener('input', () => { this.querySelector('[data-result]').textContent = ''; });
    }
    calculate() {
      const people = this.querySelector('[data-people]');
      const length = this.querySelector('[data-room-length]');
      const width = this.querySelector('[data-room-width]');
      const result = this.querySelector('[data-result]');
      if (!people.value || ![people, length, width].every(input => input.checkValidity())) {
        result.textContent = 'Angiv 2–20 personer som et helt tal og eventuelle rummål mellem 100 og 2000 cm.';
        return;
      }
      if (Boolean(length.value) !== Boolean(width.value)) {
        result.textContent = 'Udfyld både længde og bredde, eller lad begge rummål stå tomme.';
        return;
      }
      const n = Number(people.value);
      const space = Number(this.querySelector('[data-space]').value);
      const ends = this.querySelector('[data-ends]').checked ? 2 : 0;
      const perSide = Math.ceil((n - ends) / 2);
      const needed = Math.max(90, perSide * space + (ends ? 60 : 0));
      const standard = [180, 220].find(size => size >= needed);
      const recommended = standard || Math.ceil(needed / 10) * 10;
      let text = `${n} personer: ${perSide} på den længste side${ends ? ' og én ved hver bordende' : ', uden endesæder'}. Beregnet længdebehov: ${needed} cm. `;
      text += standard ? `FORM 01 på 95 × ${standard} cm opfylder modellens længdebehov. ` : `Ingen af standardlængderne 180 og 220 cm opfylder dette pladsbehov. Tal med os om ca. ${recommended} cm eller en anden siddeopstilling. `;
      const roomLength = recommended + 180;
      text += `Planlægningsmål for spiseområdet: ${roomLength} × 275 cm inkl. 90 cm omkring bordet. `;
      if (length.value && width.value) {
        text += Number(length.value) >= roomLength && Number(width.value) >= 275
          ? 'Dine angivne mål opfylder denne pladsmodel. '
          : 'Dine angivne mål er mindre end pladsmodellen kræver. Vælg ikke et mindre bord alene for at få det til at passe; få placering og antal siddepladser vurderet. ';
      }
      text += 'Anbefalingen forudsætter, at stole og bordben giver den beregnede frie siddeplads.';
      result.textContent = text;
    }
  });
}
